import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal';
import classNames from 'classnames'

import config from 'util/config.js'
import * as actions from 'ducks/modules/customize'
import { getPriceVM } from 'state/viewModels'
import { TrackedSimpleButtonLink, TrackedSimpleButton } from 'components/Buttons'
import { trackedClickEvent } from '../util/analytics'
import { Redirect } from 'react-router-dom' 

import StartOverImg from 'images/icon_startover_m.png'
import SaveImg from 'images/icon_save_heart_m.png'

export class AppNav extends Component {
  constructor() {
    super();
    this.state = {
      minPriceModalIsOpen: false,
      addToSavedResult:null,
      savedModalIsOpen: false,
      performedAutoAdd: false,
    };
    this.openPriceModal = this.openPriceModal.bind(this);
    this.closePriceModal = this.closePriceModal.bind(this);
    this.openSavedModal = this.openSavedModal.bind(this);
    this.closeSavedModal = this.closeSavedModal.bind(this);
    this.addToSavedHandler = this.addToSavedHandler.bind(this);
	this.startOverHandler = this.startOverHandler.bind(this);
  }

  componentWillMount() {
    if (this.props.autoAddToSaved && !this.state.performedAutoAdd){
      this.addToSavedHandler();
      this.setState({performedAutoAdd: true});
    }
  }

  openPriceModal() {
    this.setState({minPriceModalIsOpen: true});
  }

  closePriceModal() {
    this.setState({minPriceModalIsOpen: false});
  }

  openSavedModal() {
    this.setState({savedModalIsOpen: true});
  }

  closeSavedModal() {
    this.setState({savedModalIsOpen: false});
  }

  addToSavedHandler(){
    this.props.addToSaved().then((result) => {
      this.setState({ addToSavedResult: result.payload });
      this.openSavedModal();
    })
  }
  
  startOverHandler(){
    localStorage.removeItem('reduxState');
	window.location.href = "/customshop/customize/" + this.props.putterId;

  }

  render = () => (
  <div className={classNames("app-nav", {"is-min-price": this.props.price.isMinPrice })} >
    <span className="start-over-container">
        <TrackedSimpleButton trackingData="StartOver" className="start-over" onClick={this.startOverHandler}>
          <img className="start-over-img" src={StartOverImg} alt={`Start Over`} />
        Start Over
        </TrackedSimpleButton> 
    </span>
    <span className="save-buy-container">
      {(window._SC_IS_LOGGED_IN &&
        <TrackedSimpleButton trackingData="Save:Logged In" className="save" onClick={this.addToSavedHandler}>
          <img className="save-img" src={SaveImg} alt={`Save`} />
          <span className="save-button-text">Save</span>
        </TrackedSimpleButton> 
      ) ||
        <TrackedSimpleButton  trackingData={{outbound:true, label:"Save:Not Logged In"}} className="save" href={config.loginUrl + "?returnUrl=" + window.location.pathname + "/save"}>
          <img className="save-img" src={SaveImg} alt={`Save`} />
          <span className="save-button-text">Save</span>
        </TrackedSimpleButton> 
      }
      </span>
      <span className="saved-putter-button">
      {(window._SC_IS_LOGGED_IN &&
        <TrackedSimpleButton trackingData={{outbound:true, label:"SavedPutters: Logged In"}} className="saved-putters" href={"/custom-shop/your-putters.aspx"}> 
          Saved Putters
        </TrackedSimpleButton> 
      ) ||
        <TrackedSimpleButton  trackingData={{outbound:true, label:"SavedPutters:Not Logged In"}} className="saved-putters" href={config.loginUrl + "?returnUrl=/custom-shop/your-putters.aspx"}>
          Saved Putters
        </TrackedSimpleButton> 
      }
      </span>
      <div className="price-button-container">
        {this.props.price.isMinPrice &&
          <div>
            <span className="min-price-link" onClick={trackedClickEvent("Open Price Modal", this.openPriceModal)}>$45 Minimum Price</span>
              <Modal className="customizer modal-popup" overlayClassName="modal-overlay"
                isOpen={this.state.minPriceModalIsOpen}
                onRequestClose={this.closePriceModal}
                contentLabel="Min Price Modal"
              > 
                <div>
                  <div className="close-modal" onClick={this.closePriceModal}>X</div>
                  <div className="min-price-modal-header">$45 Minimum Price</div>
                  <div className="min-price-modal-content">We have set a minimum purchase requirement of $45.00. This amount covers the potential cost of shipping a putter back to you if we are unable to work on it. The cost of shipping to and from the Custom Shop is the customer’s responsibility.</div>
                </div>
              </Modal>
          </div>
        }
        <span className="simple button buy">Total: ${this.props.price.total}</span>
      </div>
    <Modal className="customizer modal-popup" overlayClassName="modal-overlay"
      isOpen={this.state.savedModalIsOpen}
      onRequestClose={this.closeSavedModal}
      contentLabel="Add to Saved Result Modal"
    >
      <div className="close-modal" onClick={this.closeSavedModal}>X</div>
      {(this.state.addToSavedResult && this.state.addToSavedResult.Success)
        ? <div>
            <div className="min-price-modal-header">Putter Saved</div>
            <p>Your design has been saved to Your Putters.</p>
          </div>
        : <div className="min-price-modal-header">There was a problem saving your instance.</div>
      }
    </Modal>
  </div>
  )
}

AppNav.defaultProps = {
  price: {}
}

const mapStateToProps = (state, ownProps) => {
  return { 
    price : getPriceVM(state.customize), 
	putterId: state.customize.putter.id
	
  }
}
const mapDispatchToProps = {
  addToSaved : actions.addToSaved
}

export default connect(mapStateToProps, mapDispatchToProps)(AppNav);